import { type FC, useMemo } from 'react'

export function LocalDateTime({
  date,
  timezone
}: {
  date: string
  timezone: string | undefined
}) {
  const formatted = useMemo(() => {
    const tz = timezone ?? 'UTC'

    const d = new Date(date).toLocaleString('en', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
      timeZone: tz,
      timeZoneName: 'short'
    })

    return d
  }, [date, timezone])

  return <>{formatted}</>
}

export function DateTime({ date }: { date: string }) {
  if (date == null || date.length === 0) {
    return <span></span>
  }

  const formatted = new Date(date).toLocaleString('en', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23',
    timeZoneName: 'short'
  })

  return <span>{formatted}</span>
}

export const LocalTimeZone: FC<{ timezone: string | undefined }> = ({
  timezone
}) => {
  const formatted = useMemo(() => {
    const tz = timezone ?? 'UTC'
    const d = new Date()
      .toLocaleTimeString('en', { timeZoneName: 'short', timeZone: tz })
      .split(' ')
      .pop()

    return d
  }, [timezone])

  return <>{formatted}</>
}
